import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { tenantsFeature } from './tenants/tenant.reducer';
import { TenantEffects } from './tenants/tenant.effects';
import { usersFeature } from './users/user.reducer';
import { UserEffects } from './users/user.effects';
import { loggedUserReducer } from './auth/logged-user.reducer';
import { LoggedUserEffects } from './auth/logged-user.effects';
import { rolesFeature } from './roles/role.reducer';
import { RoleEffects } from './roles/role.effects';
import { impersonationSessionsFeature } from './impersonation-sessions/impersonation-session.reducer';
import { ImpersonationSessionEffects } from './impersonation-sessions/impersonation-session.effects';
import { mcpAccessFeature } from './mcp-access/mcp-access.reducer';
import { McpAccessEffects } from './mcp-access/mcp-access.effects';

/**
 * Provides the NgRx store slices used by the admin app (tenants, users, roles, impersonation sessions).
 * Register in app.config.ts alongside provideStoreDevtools.
 */
export function provideAdminStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideStore({
      [tenantsFeature.name]: tenantsFeature.reducer,
      [usersFeature.name]: usersFeature.reducer,
      [rolesFeature.name]: rolesFeature.reducer,
      [impersonationSessionsFeature.name]: impersonationSessionsFeature.reducer,
      [mcpAccessFeature.name]: mcpAccessFeature.reducer,
      loggedUser: loggedUserReducer
    }),
    provideEffects([
      TenantEffects,
      UserEffects,
      RoleEffects,
      LoggedUserEffects,
      ImpersonationSessionEffects,
      McpAccessEffects,
    ]),
  ]);
}
